/**
 * Traduz códigos de erro do Firebase Auth/Firestore para mensagens
 * compreensíveis ao usuário final, em português.
 */
export function getFirebaseErrorMessage(error: unknown): string {
  const code = (error as { code?: string } | undefined)?.code ?? "";

  const messages: Record<string, string> = {
    "auth/invalid-email": "E-mail inválido.",
    "auth/user-disabled": "Esta conta foi desativada.",
    "auth/user-not-found": "Não encontramos uma conta com este e-mail.",
    "auth/wrong-password": "Senha incorreta.",
    "auth/invalid-credential": "E-mail ou senha incorretos.",
    "auth/email-already-in-use": "Já existe uma conta com este e-mail.",
    "auth/weak-password": "A senha é muito fraca. Use pelo menos 6 caracteres.",
    "auth/popup-closed-by-user": "Login cancelado.",
    "auth/network-request-failed": "Falha de conexão. Verifique sua internet.",
    "auth/too-many-requests": "Muitas tentativas. Aguarde um instante e tente novamente.",
  };

  return messages[code] ?? "Algo deu errado. Tente novamente em instantes.";
}
